import {useEffect, useState} from 'react';
import AdyenCheckout from '@adyen/adyen-web';
import {PAYMENT_METHODS} from './adyen.config';
import {isPartialData} from './adyen.helpers';

export const useInitializeAdyen = (payoutMethod, checkoutConfiguration) => {
    const [checkout, setCheckout] = useState();
    const [cardComponent, setCardComponent] = useState();

    async function initializeAdyen() {
        const newCheckout = await AdyenCheckout(checkoutConfiguration);
        setCheckout(newCheckout);
        return newCheckout;
    }
    useEffect(() => {
        if (!checkout && checkoutConfiguration?.session) {
            initializeAdyen();
        }
    }, [checkoutConfiguration]);

    useEffect(() => {
        if (checkout && !cardComponent) {
            const {container, configuration} = PAYMENT_METHODS[payoutMethod];
            const newCardComponent = checkout.create(container, configuration);

            if (newCardComponent.isAvailable) {
                newCardComponent.isAvailable()
                    .then(() => newCardComponent.mount('#adyen-container'))
                    .catch(checkoutConfiguration.onError);
            } else {
                newCardComponent.mount('#adyen-container');
            }

            setCardComponent(newCardComponent);
        }
    }, [checkout]);

    return {
        checkout,
        cardComponent
    };
};

export const useRedirectWhenPartialData = data => {
    useEffect(() => {
        if (isPartialData(data)) {
            window.location.assign(data.returnUrl);
        }
    }, [data]);
};
